const locale = {
	TAB_ITEMS_PRICINGS: 'Listini prezzi',
	TAB_ITEMS_MERCHPOINTS: 'Listini Merchandise',

	ITEMS_ERP_ID: 'ID ERP: {id}',

	// #region Items fields
	DETAILS_ITEMS_FIELD_TITLE: 'Titolo',
	DETAILS_ITEMS_FIELD_ERP_ID: 'ID ERP',
	DETAILS_ITEMS_FIELD_TYPE: 'Tipo Prodotto',
	DETAILS_ITEMS_FIELD_UNITOFMEASURE: 'Unità di misura',
	DETAILS_ITEMS_FIELD_SERIES: 'Serie Prodotto',
	DETAILS_ITEMS_FIELD_MEASURE: 'Misura Prodotto',
	DETAILS_ITEMS_FIELD_ORDSMINQTY: 'Quantità minima (Ordine)',
	DETAILS_ITEMS_FIELD_ORDSMULTIPLE: 'Multipli (Ordine)',
	DETAILS_ITEMS_FIELD_WARNING: 'Warning',
	DETAILS_ITEMS_FIELD_BLOCKED: 'Bloccato',
	DETAILS_ITEMS_FIELD_TAGS: 'Tag',
	// #endregion

	// #region Items Pricings
	DETAILS_ITEMS_PRICINGS_BUTTON_ADD_PRICING: 'Aggiungi riga',

	DIALOG_ITEMS_PRICINGS_DIALOG_ADD_TITLE: 'Aggiungi riga listino',
	DIALOG_ITEMS_PRICINGS_DIALOG_EDIT_TITLE: 'Modifica riga listino',

	DETAILS_ITEMS_PRICINGS_FIELD_DATE_FROM: 'Data inizio',
	DETAILS_ITEMS_PRICINGS_FIELD_DATE_TO: 'Data fine',
	DETAILS_ITEMS_PRICINGS_FIELD_PRICING_GROUP: 'Gruppo prezzi',
	DETAILS_ITEMS_PRICINGS_FIELD_COMPANY: 'Azienda',
	DETAILS_ITEMS_PRICINGS_FIELD_ORDSMINQTY: 'Quantità minima (Ordine)',
	DETAILS_ITEMS_PRICINGS_FIELD_BASE_PRICE: 'Prezzo base',
	DETAILS_ITEMS_PRICINGS_FIELD_DISCOUNTABLE: 'Scontabile',
	// #endregion

	// #region Items Merch Points
	DETAILS_ITEMS_MERCHPOINTS_FIELD_TYPE: 'Tipo',
	DETAILS_ITEMS_MERCHPOINTS_FIELD_TYPE_EARN: 'Accredito',
	DETAILS_ITEMS_MERCHPOINTS_FIELD_TYPE_PRICE: 'Costo',
	DETAILS_ITEMS_MERCHPOINTS_FIELD_DATE_FROM: 'Data inizio',
	DETAILS_ITEMS_MERCHPOINTS_FIELD_DATE_TO: 'Data fine',
	DETAILS_ITEMS_MERCHPOINTS_FIELD_PRICING_GROUP: 'Gruppo prezzi',
	DETAILS_ITEMS_MERCHPOINTS_FIELD_ORDSMULTIPLE: 'Multipli (Ordine)',
	DETAILS_ITEMS_MERCHPOINTS_FIELD_POINTS: 'Punti',

	ITEMS_MERCHPOINTS_ADD_DIALOG_TITLE: 'Aggiungi riga listino',
	ITEMS_MERCHPOINTS_EDIT_DIALOG_TITLE: 'Modifica riga listino'
	// #endregion
};

export default locale;
